// 封装国际化
import VueI18n from "vue-i18n"
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import Vue from "vue"
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    zh: Object.assign(require("@/lang/zh.json"), zhLocale),
    en: Object.assign(require("@/lang/en.json"), enLocale),
  }
});


export default  i18n;
